// src/app/components/no-internet/no-internet.component.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NetworkService } from '../../service/network.service'; // Adjust path if needed

@Component({
  selector: 'app-no-internet',
  templateUrl: './no-internet.component.html',
  styleUrls: ['./no-internet.component.scss']
})
export class NoInternetComponent {
  constructor(private router: Router, private networkService: NetworkService) {}

  /**
   * Attempts to navigate back to the previous successful route
   * or a default route if no previous route is available.
   * Also checks network status before attempting navigation.
   */
  tryAgain(): void {
    // Optional: You can explicitly check the browser's online status
    if (navigator.onLine) {
      console.log('User clicked Try Again and is online. Attempting to navigate back.');
      // After confirming online, dismiss the network status indicator (if any, like a snackbar that was there)
      this.networkService.setNetworkStatus(true); // Explicitly set to online if we're now online

      // Attempt to navigate back to the previous route if stored, or to a default dashboard.
      // You might need a more sophisticated way to store the intended previous route.
      // For simplicity, we'll navigate to '/dealers' as a common starting point.
      this.router.navigate(['/dealers']);
      // Or if you want to go back to the exact page they were trying to access:
      // You'd need to store the original attempted URL in the NetworkService or a global state.
      // Example if original route was stored in NetworkService:
      // const originalRoute = this.networkService.getOriginalFailedRoute();
      // if (originalRoute) {
      //   this.router.navigateByUrl(originalRoute);
      //   this.networkService.clearOriginalFailedRoute(); // Clear after navigation
      // } else {
      //   this.router.navigate(['/dealers']); // Default fallback
      // }

    } else {
      console.log('User clicked Try Again but is still offline.');
      // Optionally, show a temporary message or refresh the component to re-evaluate
      // The image shows a good representation, so maybe just re-display it.
      // The component's template already conveys the message.
    }
  }
}